import { Routes, Route } from "react-router-dom";
import SostaLanding from "./SostaLanding";
import PrivacyPage from "./PrivacyPage";
import TermsPage from "./TermsPage";
import SupportPage from "./SupportPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<SostaLanding />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/support" element={<SupportPage />} />
    </Routes>
  );
}
